import React from 'react';
import { Link } from 'react-router-dom';
import '../../styles/section.css';
import Header from '../../components/Header';
import Footer from '../../components/Footer';

function NLPBasics() {
    return (
        <div className="section-container">
            <Header />
            <main className="section-content">
                <p className="section-intro-paragraph">Foundational knowledge within NLP</p>
                <div className="subsection-links">
                    <Link to="/nlpbasics/data">Data & Representation</Link>
                    <Link to="/nlpbasics/ling">Linguistic Processing Techniques</Link>
                    <Link to="/nlpbasics/semantic">Semantic & Sentiment Analysis</Link>
                    <Link to="/nlpbasics/eval">Evaluation</Link>
                </div>
            </main>
            <Footer />
        </div>
    );
}

export default NLPBasics;